import { ComponentResource, DesignResource } from '@/api/serverApi'
import { BaseAccordion } from '@cfs-fixings/shared'
import { useState } from 'react'
import TBoltGroupLoads from './components/TBoltGroupLoads'
import PanelSections from '../properties/components/PanelSections'
import LoadForms from './components/LoadForms'
import LoadTypeForm, { LoadTypes } from './components/LoadTypeForm'
import { LoadsContext } from './hooks/LoadsContext'

type DesignResourceWithComponents = DesignResource & {
  components: ComponentResource[]
}

type PropTypes = {
  design: DesignResourceWithComponents
}

const LoadsOverview = ({ design }: PropTypes) => {
  const [loadType, setLoadType] = useState(LoadTypes.Design)

  return (
    <LoadsContext.Provider
      value={{
        design: design,
        loadType: loadType,
        setLoadType: setLoadType,
      }}
    >
      <PanelSections>
        <BaseAccordion
          title="Load Type"
          defaultOpen
          panelClasses="px-0 py-0"
        >
          <LoadTypeForm />
        </BaseAccordion>
        <BaseAccordion
          title="Loads"
          defaultOpen
        >
          <TBoltGroupLoads />
        </BaseAccordion>
        <LoadForms />
      </PanelSections>
    </LoadsContext.Provider>
  )
}

export default LoadsOverview
